import CheckAuthentication from '../CheckAuthentication'

const AuthorizeAccessToApp = () => (
  <CheckAuthentication />
)

export default AuthorizeAccessToApp
